import React, { useState } from "react";
import styled from "styled-components";
import { Edit } from "@mui/icons-material";
import EditPatientModal from "../shared/EditPatientModal";
import { ActionButton } from "../shared/action-button";

const InfoTable = styled.div`
  background-color: #141B25;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px 0px #00000040;
  flex: ${({ flex }) => flex || 1};
`;

const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #141B25;
  color: #7ef5fd;
  padding: 12px 0px;
  border-radius: 8px;
  margin-bottom: 16px;
`;

const TitleText = styled.p`
  margin: 0;
  font-weight: bold;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const capitalizeFirst = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

const PatientInformation = ({ patient }) => {
  const [isEditPatientModalOpen, setIsEditPatientModalOpen] = useState(false);

  const handleEditPatient = () => {
    setIsEditPatientModalOpen(true);
  };

  return (
    <div style={{ marginTop: "16px" }}>
      <InfoTable flex={2}>
        <TableHeader>
          <TitleText>Patient Information</TitleText>
          <ActionButton
            onClick={handleEditPatient}
            variantType="filled"
            startIcon={<Edit />}
          >
            Edit Patient
          </ActionButton>
        </TableHeader>

        <InfoRow>
          <span>Birth Date:</span>
          <span>
            {new Date(patient.date_of_birth).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}
          </span>
        </InfoRow>
        <InfoRow>
          <span>Gender:</span>
          <span>{capitalizeFirst(patient.gender)}</span>
        </InfoRow>
        <InfoRow>
          <span>Phone:</span>
          <span>{patient.phone || "N/A"}</span>
        </InfoRow>
        <InfoRow>
          <span>Address:</span>
          <span>{`${capitalizeFirst(
            patient.address_street || ""
          )} ${capitalizeFirst(patient.address_city || "")} ${capitalizeFirst(
            patient.address_state || ""
          )} ${patient.address_zip || ""}`}</span>
        </InfoRow>
      </InfoTable>

      <EditPatientModal
        open={isEditPatientModalOpen}
        onClose={() => setIsEditPatientModalOpen(false)}
        patient={patient}
      />
    </div>
  );
};

export default PatientInformation;
